

export const APPLICATION_API_URL = 'https://fokus-server-s64pj2el2a-ew.a.run.app/v4';

export const ANALYTICS_API_URL = 'https://fokus-analytics-server-s64pj2el2a-ew.a.run.app';
